import { useQuery } from "@tanstack/react-query";
import type { AdChannel, AdProductId, AdStatus } from "@demandhub-cms/shared";
import { adDraftsApi } from "../lib/api";

/**
 * The one way to read ad drafts. Every screen uses this key, so the same list is fetched once and shared:
 * ["ad-drafts", siteId, product, channel, status]. A screen that doesn't narrow by product, channel or status
 * passes nothing for it, and that part of the key is "all".
 */
export function adDraftsKey(siteId: string, product?: AdProductId, channel?: AdChannel, status?: AdStatus) {
  return ["ad-drafts", siteId, product ?? "all", channel ?? "all", status ?? "all"] as const;
}

export function useAdDrafts(q: { siteId: string; product?: AdProductId; channel?: AdChannel; status?: AdStatus }, opts: { enabled?: boolean; staleTime?: number; refetchOnWindowFocus?: boolean } = {}) {
  return useQuery({
    queryKey: adDraftsKey(q.siteId, q.product, q.channel, q.status),
    enabled: !!q.siteId && (opts.enabled ?? true),
    staleTime: opts.staleTime,
    refetchOnWindowFocus: opts.refetchOnWindowFocus,
    queryFn: () => adDraftsApi.list(q),
  });
}
